/* @flow */

import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import type {NutshellState} from '../../../../store';
import {closeSidebar} from './redux/actions';
import {getIsOpen, getVisitorId} from './redux/selectors';
import {VisitorsSidebar} from './v1/visitors-sidebar';
import {CompanyVisitorsSidebar} from './company-visitors-sidebar';

export function VisitorsSidebarWrapper() {
    const isOpen = useSelector((state: NutshellState) => getIsOpen(state));
    const visitorId = useSelector((state: NutshellState) => getVisitorId(state));
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(closeSidebar());
    };

    if (!isOpen || !visitorId) {
        return null;
    }

    return NutClientConfig.hasVisitorIqForContacts ? (
        <CompanyVisitorsSidebar visitorId={visitorId} onClose={handleClose} />
    ) : (
        <VisitorsSidebar visitorId={visitorId} onClose={handleClose} />
    );
}
